import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  align: {
    type: 'string',
    default: 'full',
  },
  title: {
    type: 'string',
    default: 'Mais vantagens para quem assina',
  },
  text: {
    type: 'string',
    default: 'Serviços Digitais inclusos, perfeitos para você curtir online',
  },
  ButtonText: {
    type: 'string',
  },
  hrefLink: {
    type: 'string',
  },
  ...Common,
};
